(function() {
    'use strict';

    angular.module('allegro').controller('AllegroOauthUpdateController', AllegroOauthUpdateController);

    AllegroOauthUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst'
    ];

    function AllegroOauthUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroConfigDataSrvc,
        allegroConfigMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            client_id: [],
            client_secret: [],
            base_url: [],
            base_api_url: [],
            user_agent: null,
            non_field_errors: []
        };

        self.account = {};
        self.configurationData = {
            pk: null,
            client_id: '',
            client_secret: '',
            base_url: '',
            base_api_url: '',
            user_agent: {}
        };

        self.isConnectionActive = isConnectionActive;
        self.getAccount = getAccount;
        self.getConfiguration = getConfiguration;
        self.updateConfiguration = updateConfiguration;
        self.cleanErrors = cleanErrors;

        active()
        function active(){
            self.loading = true;

            self.getConfiguration($stateParams.pk).then(function(response) {
                if (response.account) {
                    return self.getAccount(response.account);
                }
            })
            .then(function(data) {
                self.loading = false;
            });
        }

        function isConnectionActive(account){
            if (!account || !account.configuration){return false}
            return account.configuration.device_flow || account.configuration.access_token;
        }

        function getAccount(accountPk) {
            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function () {});
        }

        function getConfiguration(configurationPk){
            return allegroConfigDataSrvc.get({pk: configurationPk})
                .$promise.then(
                    function (response) {
                        response.user_agent = response.user_agent || {};
                        self.configurationData = response;
                        return response;
                    }
                ).catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                }).finally(function () {});
        }

        function updateConfiguration() {
            allegroConfigDataSrvc.update({pk: self.configurationData.pk}, self.configurationData)
                .$promise.then(function(response) {
                    notificationSrvc.notification("success", allegroConfigMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.overview', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function () {});
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
